import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { useDispatch } from "react-redux";
import TableRow from "@mui/material/TableRow";
import {
  Box,
  Card,
  Grid,
  IconButton,
  TableFooter,
  TablePagination,
  useTheme,
  Chip,
} from "@mui/material";

import {
  CustomTableContainer,
  CustomTableHead,
  TableContentVendorFont,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  RemoveRedEye,
} from "@mui/icons-material";
import PropTypes from "prop-types";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  ButtonLink,
  DisplayText,
} from "../../bankDetails/components/bankAccountsContent";
import empty from "../../../assets/illo.png";
import { getOrders } from "../redux/adminOrdersSlice";
import moment from "moment";
import { Link } from "react-router-dom";
import LocalStorage from "../../../utilities/localStorage";

const EmptyContainer = ({ role }) => (
  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justifyContent="center"
  >
    <br />
    <img src={empty} alt="empty" />
    <DisplayText> There are no orders to display</DisplayText>
    <br />
    {role === "Admin" || role === "finance" ? (
      ""
    ) : (
      <ButtonLink to="/app/orders">+ Add Orders</ButtonLink>
    )}

    <br />
    <br />
  </Grid>
);

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return (
    <>
      <Box sx={{ flexShrink: 0 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    </>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function AdminOrdersTableContent({ fileOpen }) {
  const { pending } = useSelector((state) => state.pendinglist);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const { ordersList } = useSelector((state) => state.adminOrders);
  const dispatch = useDispatch();
  const role = LocalStorage.getItem("tata_login_user").roles;

  const orders = () => {
    dispatch(getOrders());
  };

  useEffect(() => {
    orders();
    // eslint-disable-next-line
  }, [fileOpen]);


  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - pending.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <CustomTableContainer component={Card}>
      <Table aria-label="simple table">
        <CustomTableHead>
          <TableRow>
            <TableCell>
              <TableHeaderFont>Vendor</TableHeaderFont>
            </TableCell>
            <TableCell>
              <TableHeaderFont>Buyer Company</TableHeaderFont>
            </TableCell>
            <TableCell align="left">
              <TableHeaderFont>Department</TableHeaderFont>
            </TableCell>
            <TableCell align="left">
              <TableHeaderFont>Type</TableHeaderFont>
            </TableCell>
            <TableCell align="left">
              <TableHeaderFont>Order Number</TableHeaderFont>
            </TableCell>
            <TableCell align="left">
              <TableHeaderFont>Amount</TableHeaderFont>
            </TableCell>
            <TableCell align="left">
              <TableHeaderFont>Date</TableHeaderFont>
            </TableCell>
            <TableCell align="left">
              <TableHeaderFont>Status</TableHeaderFont>
            </TableCell>
            <TableCell align="center">
              <TableHeaderFont>Action</TableHeaderFont>
            </TableCell>
          </TableRow>
        </CustomTableHead>
        {ordersList.length !== 0 ? (
          <TableBody>
            {(rowsPerPage > 0
              ? ordersList.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : ordersList
            ).map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  <Link
                    style={{ textDecoration: "none" }}
                    // eslint-disable-next-line
                    to={"/app/orders-list-view/" + `${row.id}`}
                  >
                    <TableContentVendorFont>
                      {row.VendorCompanyName !== null
                        ? row.VendorCompanyName
                        : "Not Applicable"}
                    </TableContentVendorFont>
                  </Link>
                </TableCell>
                <TableCell>
                  {row.BuyerCopmanyName !== null
                    ? row.BuyerCopmanyName
                    : "Not Applicable"}
                </TableCell>
                <TableCell>
                  {row.organizational_unit !== null
                    ? row.organizational_unit
                    : "Not Applicable"}
                </TableCell>
                <TableCell>
                  {row.type !== null ? row.type : "Not Applicable"}
                </TableCell>
                <TableCell>
                  {row.order_number !== null
                    ? row.order_number
                    : "Not Applicable"}
                </TableCell>
                <TableCell>
                  {row.order_amount !== null
                    ? row.order_amount
                    : "Not Applicable"}
                </TableCell>
                <TableCell>
                  {row.createdAt !== null
                    ? moment(row.createdAt).format("DD MMM YY")
                    : "Not Applicable"}
                </TableCell>
                <TableCell>
                  {row.status !== null ? (
                    <Chip
                      label={row.status.toUpperCase()}
                      color={row.status === "Pending" ? "warning" : "success"}
                      size="small"
                      style={{ fontSize: "9px" }}
                    />
                  ) : (
                    "Not Applicable"
                  )}
                </TableCell>
                <TableCell style={{ textAlign: "center" }}>
                  <Link
                    style={{ textDecoration: "none" }}
                    // eslint-disable-next-line
                    to={"/app/orders-list-view/" + `${row.id}`}
                  >
                    <RemoveRedEye
                      style={{
                        fill: "royalblue",
                        height: "18px",
                        width: "18px",
                      }}
                    />
                  </Link>
                </TableCell>
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 0 * emptyRows }}></TableRow>
            )}
          </TableBody>
        ) : (
          <TableBody>
            <TableRow>
              <TableCell colSpan={8}>
                <CustomTableContainer>
                  <EmptyContainer role={role[0]} />
                </CustomTableContainer>
              </TableCell>
            </TableRow>
          </TableBody>
        )}
        <TableFooter style={{ borderTop: "1px solid lightgray" }}>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[]}
              colSpan={8}
              count={ordersList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  "aria-label": "rows per page",
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </CustomTableContainer>
  );
}

export default AdminOrdersTableContent;
